import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import shopModule from "./module/shop";
import Index from "@views/padAdmin/index";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import Loading from "@views/Loading";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/padAdmin"
    },
    {
      path: "/padAdmin",
      name: "Index",
      meta: {
        title: "首页",
        keepAlive: false,
        auth: true,
        home: false,
        header: true,
        footer: true,
        backgroundColor: "#fff"
      },
      component: Index
    },
    ...module,
    ...shopModule,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true
      },
      component: Loading
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function() {
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  console.log(to)
  console.log('---------')
  console.log(form)
  console.log('---------')
  console.log(next)
  const { title, backgroundColor, footer, home, auth, header} = to.meta;
	router.app.$options._prevRoute = form || {}

  document.title = title || process.env.VUE_APP_NAME || "樂雅健康";

  auth === true ? $store.commit("ADD_AUTH") : $store.commit("REMOVE_AUTH");
  header === true ? $store.commit("SHOW_HEADER") : $store.commit("HIDE_HEADER");
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

Vue.prototype.$prevRoute = () => {
  return router.app.$options._prevRoute
}

export default router;
